import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import commonENG from "./locales/eng/common.json";
import errorInvoiceENG from "./locales/eng/errorInvoice.json";
// import workflowsManagementENG from "./locales/eng/workflowsManagement.json";
import businessUnitENG from "./locales/eng/GeneralInfo/businessUnit.json";
import currencyManagerENG from "./locales/eng/GeneralInfo/currencyManager.json";
import customerENG from "./locales/eng/GeneralInfo/customer.json";
import invoiceSymbolENG from "./locales/eng/GeneralInfo/invoiceSymbol.json";
import paymentMethodManagerENG from "./locales/eng/GeneralInfo/paymentMethodManager.json";
import productENG from "./locales/eng/GeneralInfo/product.json";
import VATManagerENG from "./locales/eng/GeneralInfo/VATManager.json";
import issueInvoiceENG from "./locales/eng/issueInvoice.json";
// ENG
import noticeFromTCTENG from "./locales/eng/noticeFromTCT.json";
import registryDelegateENG from "./locales/eng/registryDelegate.json";
import registryInvoiceENG from "./locales/eng/registryInvoice.json";
import requestInvoiceCodeENG from "./locales/eng/requestInvoiceCode.json";
import summaryInvoiceDataENG from "./locales/eng/summaryInvoiceData.json";
import translationENG from "./locales/eng/translation.json";
import warehouseAgencyENG from "./locales/eng/warehouseAgency.json";
import invoiceTemplateENG from "./locales/eng/invoiceTemplates.json";

import businessInfoENG from "./locales/eng/businessInfo.json";
import businessConfigurationENG from "./locales/eng/businessConfiguration.json";
import businessEmailTemplateENG from "./locales/eng/businessEmailTemplates.json";
// VN
// import caseManagementVN from "./locales/vn/caseManagement.json";
import commonVN from "./locales/vn/common.json";
import {
  default as deliveryBillENG,
  default as deliveryBillVN,
} from "./locales/vn/deliveryBill.json";
import errorInvoiceVN from "./locales/vn/errorInvoice.json";
// import workflowsManagementVN from "./locales/vn/workflowsManagement.json";
import businessUnitVN from "./locales/vn/GeneralInfo/businessUnit.json";
import currencyManagerVN from "./locales/vn/GeneralInfo/currencyManager.json";
import customerVN from "./locales/vn/GeneralInfo/customer.json";
import invoiceSymbolVN from "./locales/vn/GeneralInfo/invoiceSymbol.json";
import paymentMethodManagerVN from "./locales/vn/GeneralInfo/paymentMethodManager.json";
import productVN from "./locales/vn/GeneralInfo/product.json";
import VATManagerVN from "./locales/vn/GeneralInfo/VATManager.json";
import issueInvoiceVN from "./locales/vn/issueInvoice.json";
import noticeFromTCTVN from "./locales/vn/noticeFromTCT.json";
import registryDelegateVN from "./locales/vn/registryDelegate.json";
import registryInvoiceVN from "./locales/vn/registryInvoice.json";
import requestInvoiceCodeVN from "./locales/vn/requestInvoiceCode.json";
import summaryInvoiceDataVN from "./locales/vn/summaryInvoiceData.json";
import translationVN from "./locales/vn/translation.json";
import warehouseAgencyVN from "./locales/vn/warehouseAgency.json";
import invoiceTemplateVN from "./locales/vn/invoiceTemplates.json";
import businessInfoVN from "./locales/vn/businessInfo.json";
import businessConfigurationVN from "./locales/vn/businessConfiguration.json";
import businessEmailTemplateVN from "./locales/vn/businessEmailTemplates.json";

// the translations
const resources = {
  en: {
    translation: translationENG,
    common: commonENG,

    // caseManagement: caseManagementENG,
    // workflowsManagement: workflowsManagementENG,
    businessUnit: businessUnitENG,
    currencyManager: currencyManagerENG,
    paymentMethodManager: paymentMethodManagerENG,
    VATManager: VATManagerENG,
    invoiceSymbol: invoiceSymbolENG,
    errorInvoice: errorInvoiceENG,
    registryInvoice: registryInvoiceENG,
    registryDelegate: registryDelegateENG,
    requestInvoiceCode: requestInvoiceCodeENG,
    noticeFromTCT: noticeFromTCTENG,
    issueInvoice: issueInvoiceENG,
    summaryInvoiceData: summaryInvoiceDataENG,
    deliveryBill: deliveryBillENG,
    product: productENG,
    customer: customerENG,
    warehouseAgency: warehouseAgencyENG,
    invoiceTemplate: invoiceTemplateENG,
    businessInfo: businessInfoENG,
    businessConfiguration: businessConfigurationENG,
    businessEmailTemplate: businessEmailTemplateENG,
  },
  vn: {
    translation: translationVN,
    common: commonVN,
    // jobTitle: jobTitleVN,
    // templateManagement: templateManagementVN,
    // caseManagement: caseManagementVN,
    // eDocumentManagement: eDocumentManagementVN,
    // employeeManagement: employeeManagementVN,
    // workflowsManagement: workflowsManagementVN,
    businessUnit: businessUnitVN,
    currencyManager: currencyManagerVN,
    paymentMethodManager: paymentMethodManagerVN,
    VATManager: VATManagerVN,
    invoiceSymbol: invoiceSymbolVN,
    errorInvoice: errorInvoiceVN,
    registryInvoice: registryInvoiceVN,
    registryDelegate: registryDelegateVN,
    requestInvoiceCode: requestInvoiceCodeVN,
    noticeFromTCT: noticeFromTCTVN,
    issueInvoice: issueInvoiceVN,
    summaryInvoiceData: summaryInvoiceDataVN,
    deliveryBill: deliveryBillVN,
    product: productVN,
    customer: customerVN,
    warehouseAgency: warehouseAgencyVN,
    invoiceTemplate: invoiceTemplateVN,
    businessInfo: businessInfoVN,
    businessConfiguration: businessConfigurationVN,
    businessEmailTemplate: businessEmailTemplateVN,
  },
};

const language = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "vn");
}

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "vn",
    fallbackLng: "en", // use en if detected lng is not available

    // keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;
